module.exports = __webpack_public_path__ + "img/logo.3d9c1e41.jpg";